import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
// import { RiMenu5Fill } from "react-icons/ri"; //
import { BsHeart } from "react-icons/bs";

import { connect } from "react-redux";

const Navbar = ({ cart }) => {
  const [cartCount, setCartCount] = useState(0);

  const [showHamburger, setShowHamburger] = useState(false); //

  const handleClick = () => setShowHamburger(!showHamburger); //

  useEffect(() => {
    let count = 0;
    cart.forEach((cartItem) => {
      //loops thru cart array
      count += cartItem.qty;
    });
    setCartCount(count);
  }, [cart, cartCount]);

  return (
    <>
      <nav className="navbarContent">
        <div className="logoTitleNav">
          <img src="./egg.png" alt="logo" width="50vw" />
          <h1>The Naked Egg</h1>
        </div>
        {/* <button onClick={() => setShowHamburger(!showHamburger)}> */}
        <button onClick={handleClick}>
        <i className={showHamburger ? "ri-close-line" : "ri-menu-5-line"}></i>
          {/* <RiMenu5Fill />  */}
          
        </button>
        <div className="navLink" id={showHamburger ? "hidden" : ""}>
        <NavLink exact activeClassName="active" to="/" className="homeNav navLinks" onClick={handleClick}>
          Home
        </NavLink>
        <NavLink activeClassName="active" to="/ourstory" className="storyNav navLinks" onClick={handleClick}>
          Our Story
        </NavLink>
        <NavLink activeClassName="active"to="/productoverview" className="productsNav navLinks" onClick={handleClick}>
          Our Products
        </NavLink>

        <NavLink activeClassName="active" to="/favorites" className="navLinks" onClick={handleClick}>
            <BsHeart className='BsHeart'/>
          </NavLink>

          <NavLink activeClassName="active" to="/cart" className="basketNav navLinks" onClick={handleClick}>
          Basket<i className="ri-shopping-basket-line"></i>&nbsp;{cartCount}
        </NavLink>
        <NavLink activeClassName="active" to="/login" className="loginNav navLinks" onClick={handleClick}>
          Login
        </NavLink>
        </div>
      </nav>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.shop.cart,
  };
};

export default connect(mapStateToProps)(Navbar);
